import { applyMiddleware, compose, createStore, combineReducers } from 'redux';
import { routerReducer } from 'react-router-redux';
import thunk from 'redux-thunk';
import { createTracker } from 'redux-segment';
import reducers from '../reducers';
import cards from '../cards/reducers';

// Create Segment Tracker
const tracker = createTracker();

/* eslint no-underscore-dangle: ["error", { "allow": ["__REDUX_DEVTOOLS_EXTENSION_COMPOSE__"] }] */

const composeEnhancers = (window.zola.env === 'development' || window.zola.env === 'staging') ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose : compose;

// old in case I'm terribly mistaken
// const composeEnhancers = (process.env.NODE_ENV === 'development' || process.env.NODE_ENV === 'staging') ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose : compose;

const enhancers = composeEnhancers(
  applyMiddleware(thunk, tracker)
);

const finalReducers = combineReducers({
  ...reducers,
  cards,
  routing: routerReducer
});

export default createStore(finalReducers, enhancers);



/** WEBPACK FOOTER **
 ** ./src/store/index.js
 **/